// =====================================
//
//   紅利點數 相關功能 Service
//   Author: Gray
//   createtime: 2017 / 07 / 13
//   updatetime: 2017 / 07 / 13
//
// =====================================

window.InifECShared.factory("BonusPointsService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // 最新紅利資訊
    var lastBonusPoints = {
        bonusRemainder: 0, // 餘額
        createtime: undefined, // 建立時間
        deadline: undefined, // 期限
    };

    // --------------------------------
    // 重置紅利資訊
    // --------------------------------
    var resetLastBonusPoints = function() {

        factory.lastBonusPoints.bonusRemainder = 0;
        factory.lastBonusPoints.createtime = undefined;
        factory.lastBonusPoints.deadline = undefined;
    }

    // --------------------------------
    // 取得會員紅利點數
    // --------------------------------
    var getUserBonusPoints = function() {

       var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/BonusPointsAction.do",
            method: "GET",
            params: {
                op: "getUserBonusPoints"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if(data && data.bonusPointsid) {
                    factory.lastBonusPoints.bonusRemainder = data.bonusRemainder;
                    factory.lastBonusPoints.createtime = data.createtime;
                    factory.lastBonusPoints.deadline = data.deadline;
                }

                defer.resolve(factory.lastBonusPoints);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : BonusPointsService.getUserBonusPoints request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得會員自己的紅利記錄
    // --------------------------------
    var getBonusPointsList = function(start, len, startdate, enddate) {

        var defer = $q.defer();

        $http({
            url: "/BonusPointsAction.do",
            method: "GET",
            params: {
                op: "getBonusPointsList",
                start: start,
                len: len,
                startdate: startdate,
                enddate: enddate,
            }
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }            
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : BonusPointsService.getBonusPointsList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.lastBonusPoints = lastBonusPoints; // 最新紅利資訊

    /*==========================
        Methods
    ==========================*/
    factory.resetLastBonusPoints = resetLastBonusPoints; // 重置紅利資訊
    factory.getUserBonusPoints = getUserBonusPoints; // 取得會員紅利點數
    factory.getBonusPointsList = getBonusPointsList; // 取得會員自己的紅利記錄

    return factory;
}]);